// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import Orders from "views/Orders/Orders.js";
import ReturnOrders from "views/ReturnOrders/ReturnOrders.js";
import Customers from "views/Customers/Customers.js";
import Subscriptions from "views/Subscriptions/Subscriptions.js";
import SubscriptionSpaceHistory from "views/SubscriptionSpaceHistory/SubscriptionSpaceHistory.js";
import otherSetting from "views/OtherSetting/OtherSetting.js";
// import ProductPrices from "views/ProductPrices/ProductPrices.js";
import Carriers from "views/Carriers/index.js";
import Warehouses from "views/Warehouses/index.js";
import PackagingMaterials from "views/PackagingMaterials/PackagingMaterials.js";
import OneTimeCost from "views/OneTimeCost/OneTimeCost.js";
import StripePricing from "views/StripePricing/StripePricing.js";
import CalendarView from "views/CalendarView/CalendarView.js";

// Function to get routes with i18n keys
const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    nameKey: "nav.dashboard",
    icon: "dashboard",
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/orders",
    name: "Pickup Orders",
    nameKey: "nav.pickupOrders",
    icon: "shop_two",
    component: Orders,
    layout: "/admin"
  },
  {
    path: "/return-orders",
    name: "Return Orders",
    nameKey: "nav.returnOrders",
    icon: "assignment_return",
    component: ReturnOrders,
    layout: "/admin"
  },
  {
    path: "/calendar",
    name: "Calendar",
    nameKey: "nav.calendar",
    icon: "calendar_today",
    component: CalendarView,
    layout: "/admin"
  },
  {
    path: "/customers",
    name: "Customers",
    nameKey: "nav.customers",
    icon: "people_alt",
    component: Customers,
    layout: "/admin"
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    nameKey: "nav.subscriptions",
    icon: "cached",
    component: Subscriptions,
    layout: "/admin"
  },
  {
    path: "/subscription-space-history",
    name: "Space history",
    nameKey: "nav.spaceHistory",
    icon: "history",
    component: SubscriptionSpaceHistory,
    layout: "/admin"
  },
  // {
  //   path: "/products",
  //   name: "Products",
  //   nameKey: "nav.products",
  //   icon: "inventory_icon",
  //   component: ProductPrices,
  //   layout: "/admin"
  // },
  {
    path: "/carriers",
    name: "Carriers",
    nameKey: "nav.carriers",
    icon: "supervisor_account_icon",
    component: Carriers,
    layout: "/admin"
  },
  {
    path: "/warehouses",
    name: "Warehouses",
    nameKey: "nav.warehouses",
    icon: "store_icon",
    component: Warehouses,
    layout: "/admin"
  },
  // {
  //   path: "/shipping-cost",
  //   name: "Pickup Costs",
  //   nameKey: "nav.pickupCosts",
  //   icon: "local_shipping",
  //   component: shippingCosts,
  //   layout: "/admin"
  // },
  // {
  //   path: "/return-cost",
  //   name: "Return Cost",
  //   nameKey: "nav.returnCost",
  //   icon: "local_shipping",
  //   component: returnCosts,
  //   layout: "/admin"
  // },
  {
    path: "/packaging-materials",
    name: "Packaging Materials",
    nameKey: "nav.packagingMaterials",
    icon: "inventory_2",
    component: PackagingMaterials,
    layout: "/admin"
  },
  {
    path: "/one-time-cost",
    name: "One Time Cost",
    nameKey: "nav.oneTimeCost",
    icon: "monetization_on",
    component: OneTimeCost,
    layout: "/admin"
  },
  {
    path: "/stripe-pricing",
    name: "Stripe Pricing",
    nameKey: "nav.stripePricing",
    icon: "payments",
    component: StripePricing,
    layout: "/admin"
  },
  {
    path: "/settings",
    name: "Settings",
    nameKey: "nav.settings",
    icon: "settings",
    component: otherSetting,
    layout: "/admin"
  }

  // {
  //   path: "/subscriptions",
  //   name: "subscriptions",
  //   icon: "subscriptions",
  //   component: TableList,
  //   layout: "/admin",
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   icon: LocationOn,
  //   component: Maps,
  //   layout: "/admin"
  // }
];

export default routes;
